import api from "@/api/v1-jwt/config/api";

export const getAllContacts = async (userId) => {
  try {
    const { data } = await api.get(`/platform/contacts/${userId}`);

    return data?.data;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getContactById = async ({ userId, contactId }) => {
  if (!userId) {
    throw new Error("[GET_CONTACTS] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[GET_CONTACTS] Contact ID missing.");
  }

  try {
    const { data } = await api.get(
      `/platform/contacts/${userId}?contact_id=${contactId}`
    );

    return data?.data;
  } catch (error) {
    console.log(error);
  }
};

export const getContactByName = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[GET_CONTACT_BY_NAME] User ID missing.");
  }

  if (payload === undefined || payload === null) {
    throw new Error("[GET_CONTACT_BY_NAME] Payload missing.");
  }

  const { data } = await api.post(`/platform/contacts/contact/by_name`, {
    ...payload,
    cognito_id: userId,
  });

  return data;
};

export const createContact = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[CREATE_CONTACT] User ID missing.");
  }

  if (payload === undefined || payload === null) {
    throw new Error("[CREATE_CONTACT] Payload missing.");
  }

  const { data } = await api.post(`/platform/contacts/${userId}`, payload);
  return data;
};

export const updateContact = async ({ userId, contactId, payload }) => {
  if (!userId) {
    throw new Error("[UPDATE_CONTACT] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[UPDATE_CONTACT] Contact ID missing.");
  }

  if (payload === undefined || payload === null) {
    throw new Error("[UPDATE_CONTACT] Payload missing.");
  }

  const { data } = await api.patch(
    `/platform/contacts/${userId}/${contactId}`,
    payload
  );

  return data;
};

export const deleteContact = async ({ userId, contactId }) => {
  if (!userId) {
    throw new Error("[DELETE_CONTACT] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[DELETE_CONTACT] Contact ID missing.");
  }

  const { data } = await api.delete(
    `/platform/contacts/${userId}/${contactId}`
  );
  return data;
};

export const saveBankInfo = async ({
  userId,
  contactId,
  nameOnAccount,
  values,
}) => {
  if (!userId) {
    throw new Error("[SAVE_BANK_INFO] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[SAVE_BANK_INFO] Contact ID missing.");
  }

  const bank_data = {
    name_on_account: nameOnAccount,
    ach: {
      account_number: values.account,
      routing_number: values.routing,
      account_type: values.accountType,
    },
  };

  const { data } = await api.post(
    `/platform/contacts/add_bank/${userId}/${contactId}`,
    bank_data
  );

  return data;
};
